import React from 'react';
import PropTypes from 'prop-types';
import {CSVLink} from 'react-csv';
import {Button} from 'reactstrap';
import {Tooltip} from "@material-ui/core";

class TableHeaderRight extends React.Component {
	static propTypes = {
		name: PropTypes.string,
		showCSV: PropTypes.bool,
		csvData: PropTypes.array,
		onReload: PropTypes.func,
		onClear: PropTypes.func,
		children: PropTypes.any, //Element or Array of Elements

	};

	static defaultProps = {
		name: 'collection',
		showCSV: true,
		csvData: [],
		onReload: null,
		onClear: null,
		children: null,

	};

	componentDidMount() {
		let {name} = this.props;

		this.fileName = `${name}.csv`;
	}

	render() {
		const {children, csvData, showCSV, onReload, onClear} = this.props;

		return (
			<div className="TableHeaderRight">
				{children}
				{csvData.length > 0 && showCSV ?
					<div className={`${!children ? 'ml-auto ' : ' '}download`}>
						<Tooltip title={"Download"} placement={"top"}>
							<CSVLink
								data={csvData}
								filename={this.fileName}
								className="btn btn-secondary"
								target="_blank"
							>
								<i className="fa fa-download"/>
							</CSVLink>
						</Tooltip>
					</div> : null}
				{onClear &&
				<div className="refresh">
					<Tooltip title={"Clear Filters"} placement={"top"}>
						<Button color="secondary" onClick={onClear}>
							<i className="fa fa-trash"/>
						</Button>
					</Tooltip>
				</div>}
				{onReload &&
				<div className="refresh">
					<Tooltip title={"Refresh"} placement={"top"}>
						<Button color="secondary" onClick={onReload}>
							<i className="fa fa-refresh"/>
						</Button>
					</Tooltip>
				</div>}
			</div>
		);
	}
}

export default TableHeaderRight;
